import { TimePicker as TimePickerRoot } from '@mui/x-date-pickers/TimePicker';
import { FormControl, FormHelperText } from '@mui/material';

interface ITimePicker {
  helperText?: boolean | string;
  onChange: (value: Date | null) => void;
  label: string;
  value: Date | null;
  name?: string;
  onBlur?: () => void;
  error?: boolean;
  placeholder?: string;
  disabled?: boolean;
}

export const TimePicker = ({
  helperText,
  onChange,
  label,
  value,
  name,
  onBlur,
  error,
  placeholder = 'HH:MM',
  disabled,
}: ITimePicker) => {
  return (
    <FormControl>
      <TimePickerRoot
        label={label}
        value={value}
        onChange={onChange}
        disabled={disabled}
        slotProps={{
          textField: {
            variant: 'standard',
            fullWidth: true,
            placeholder,
            onBlur,
            error,
            name,
          },
        }}
      />
      <FormHelperText sx={{ ml: 0 }} error={error}>
        {helperText}
      </FormHelperText>
    </FormControl>
  );
};
